import { createBrowserHistory } from 'history';
// import createBrowserHistory from 'history/createBrowserHistory'


export const history = createBrowserHistory();